module.exports = __webpack_public_path__ + "static/media/profile-header-default.8d26778b.jpg";